import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        minWidth: '540px',
        padding: '1.5rem'
    },
    logoBlock: {
        paddingRight: '.3rem',
        padding: '.3rem'
    },
    logo: {
        height: '30px',
        width: '30px',
        paddingRight: '.5rem'
    },
    icon: {
        alignSelf: 'center',
        paddingRight: '.6rem'
    },
    cancelButton: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end'
    },
    title: {
        padding: '.5rem 1.5rem 0 1.5rem',
        fontSize: '1.5rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        fontWeight: 'bold' as 'bold'
    },
    titleText: { overflowWrap: 'break-word' as const },
    paperWidthXl: { width: '40%' }
}));